module.exports = __webpack_public_path__ + "static/media/chiayi_logo.6e880e89.svg";